import axios from 'axios';

export default class DspService{
    constructor( baseURL ){
        const headers = {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        };

        this.instance = axios.create( {
            baseURL,
            headers,
            withCredentials: true
        } );
    }

    getApprovedApps(){
        return this.instance.get( '/v1/appswitcher/registry', { params: { appType: 'admin' } } )
            .then( res => res );
    }
}
